import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=05ed77e0&scoped=true&"
import script from "./Exam.vue?vue&type=script&lang=js&"
export * from "./Exam.vue?vue&type=script&lang=js&"
import style0 from "./Exam.vue?vue&type=style&index=0&id=05ed77e0&prod&lang=css&"
import style1 from "./Exam.vue?vue&type=style&index=1&id=05ed77e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed77e0",
  null
  
)

export default component.exports